<template>
  <div 
		class="enterprise_re"
		v-touch:swipe.left="touchLeft"
		v-touch:swipe.right="touchRight"
	>
   <h2 class="title">企业版 · 安全办公</h2>
   <h2 class="title">高性能 统一管控</h2>
    <div class="tabs_box">
      <div
				v-for="(item, index) in tabsList"
				:class="[`tabs_box_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
				@click="chooseTabs(index + 1)" :key="item"
			>
				{{item}}
			</div>
      <div class="tabs_box_bg" :style="tabStyle"></div>
    </div>
		<div class="content-wrap">
			<div
				v-for="(item, index) in itemList"
				:class="['item_box', `item_box_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
				:key="index"
			>
				<p class="dt-title">{{ itemList[currIdx - 1]['detailList'][currDetailClickIdx - 1].title }}</p>
				<div class="video_box">
					<div 
						v-for="(mediaItem, mIdx) in item.video" v-if="mIdx + 1 == currDetailClickIdx" :key="mediaItem.url"
						:class="['media_item']"
					>
						<video
							:ref="`media_${index + 1}_${mIdx + 1}`"
							v-if="mediaItem.type == 'video' && mIdx + 1 == currDetailClickIdx && index + 1 == currIdx"
							:autoplay="false"
							muted
							loop
							draggable="false"
							playsinline
							playsinlinex5-video-player-type="h5"
							x5-video-player-fullscreen="true"
							x5-playsinline="true"
							x-webkit-airplay="allow"
							x5-video-orientation="landscape|portrait"
							style="object-fit: fill"
							webkit-playsinline="true"
							x5-video-player-type="h5-page"
							controls
						>
							<source :src="mediaItem.url" type="video/mp4">
							您的浏览器不支持视频播放。
						</video>
						<img v-if="mediaItem.type == 'img'" :src="mediaItem.url" alt="">
					</div>
				</div>
				<div class="text_box">
					<div class="detail_box">
						<div 
							v-for="(detail, dIndex) in item.detailList"
							:class="['detail_item', dIndex + 1 == currDetailClickIdx ? 'active' : '']"
							:key="dIndex"
						>
							<div class="dl-text-wrap">
								<p v-for="text in detail.text" class="dt-text" :key="text">{{ text }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="indicator_wrap">
					<i v-for="(detail, index) in item.detailList" :class="['indicator_item', index + 1 == currDetailClickIdx ? 'active' : '']" @click="handleChoseMedia(index + 1)" :key="index"></i>
				</div>
			</div>
		</div>
		<a class="dl_btn" href="https://www.todesk.com/mobile/#/helpcenter/enterprise/89">了解更多</a>
  </div>
</template>

<script>
export default {
  name: "Enterprise",
  data() {
    return {
			currIdx: 1,
			currDetailClickIdx: 1,
			tabsList: ['更流畅', '更高性能', '更高效',],
			itemList: [
				{
					video: [
						{
							type: 'img',
							url: 'https://todeskcdnspeed.todesk.com/2023091214092060523489f42524.png',
						},
						{
							type: 'video',
							url: 'https://todeskcdnspeed.todesk.com/202207201222075e434f1a8eab44.mp4',
						}
					],
					detailList: [
						{
							title: '专享企业版高速线路',
							text: [
								'持久稳定连接，不卡顿、不掉线',
								'字体清晰强化，写文档、码代码更轻松',
								'高清高帧，精准响应，满足三维设计与图形操作',
							],
						},
						{
							title: 'SOS极简被控端',
							text: ['3秒下载，1键直连']
						},
					],
				},
				{
					video: [
						{
							type: 'video',
							url: 'https://todeskcdnspeed.todesk.com/202206121646015e13c337a1451c.mp4',
						},
						{
							type: 'img',
							url: 'http://todeskcdnspeed.todesk.com/20230908154122604d41a626438c.png',
						},
					],
					detailList: [
						{
							title: '精准覆盖主流应用软件',
							text: [
								'支持MAYA、Unity、3DS-MAX、Photoshop...',
								'4K高清画面，满足三维设计与图形操作',
								'兼容2048数位板，体感卡顿率≤0.3%',
							],
						},
						{
							title: '全面支持各大高清应用场景',
							text: ['设计、影音、游戏...']
						},
					],
				},
				{
					video: [
						{
							type: 'video',
							url: 'https://todeskcdnspeed.todesk.com/videos/swsb.mp4',
						},
						{
							type: 'video',
							url: 'https://todeskcdnspeed.todesk.com/videos/zhxx.mp4',
						},
						{
							type: 'img',
							url: 'https://todeskcdnspeed.todesk.com/202305191607355fc0769e3fee1c.png',
						}
					],
					detailList: [
						{
							title: '上万设备快速安装',
							text: ['命令行静默部署，一条命令完成安装、绑定',]
						},
						{
							title: '账号信息一键同步',
							text: ['可对接公司AD域、飞书、企微账号，', '批量导入用户信息']
						},
						{
							title: '即刻开启安全远控',
							text: ['员工只需下载主控端并登录，', '即可无缝切换远程办公']
						},
					],
				},
			],
    };
  },
	computed: {
		tabStyle() {
			switch (this.currIdx) {
				case 1:
					return `left: ${0 / 375 * 100}vw; width:${102 / 375 * 100}vw;`
				case 2:
					return `left: ${102 / 375 * 100}vw; width:${104 / 375 * 100}vw;`
				case 3:
					return `left: ${205 / 375 * 100}vw; width:${90 / 375 * 100}vw;`
				default:
					return ''
			}
		}
	},
  beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
		window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
		chooseTabs(index = 1) {
			if (this.currIdx == index) return
			this.currIdx = index
			this.currDetailClickIdx = 1
			this.$nextTick(() => {
				const dom = this.$refs[`media_${this.currIdx}_${1}`]
				if (dom && dom[0]) {
					dom[0].play()
				}
			})
		},
		handleChoseMedia(index = 1) {
			if(this.currDetailClickIdx == index) return
			this.currDetailClickIdx = index
			this.$nextTick(() => {
				const dom = this.$refs[`media_${this.currIdx}_${index}`]
				if (dom && dom[0]) {
					dom[0].play()
				}
			})
		},
		handleScroll() {
			const dom = this.$refs[`media_${this.currIdx}_${this.currDetailClickIdx}`]
			if (dom && dom[0]) {
				const clientHeight = document.documentElement.clientHeight
				const domClientHeight = dom[0].clientHeight
				const bdRect = dom[0].getBoundingClientRect()
				if(bdRect.bottom - domClientHeight < clientHeight && bdRect.bottom >= 0) {
					dom[0].play()
				} else {
					dom[0].pause()
				}
			}
		},
		touchLeft() {
			if (this.currDetailClickIdx + 1 > this.itemList[this.currIdx - 1]['detailList'].length) {
				this.currIdx++
				this.currDetailClickIdx = 1
			} else {
				this.currDetailClickIdx++
			}
			if(this.currIdx == this.itemList.length + 1){
        this.currIdx = 1;
				this.currDetailClickIdx = 1;
      }
			this.$nextTick(() => {
				const dom = this.$refs[`media_${this.currIdx}_${this.currDetailClickIdx}`]
				if (dom && dom[0]) {
					dom[0].play()
				}
			})
		},
		touchRight() {
			if (this.currDetailClickIdx - 1  === 0) {
				if(this.currIdx - 1 === 0){
					this.currIdx = this.itemList.length;
					this.currDetailClickIdx = this.itemList[this.currIdx - 1]['detailList'].length
				} else {
					this.currIdx--
					this.currDetailClickIdx = this.itemList[this.currIdx - 1]['detailList'].length
				}
			} else {
				this.currDetailClickIdx--
			}
			this.$nextTick(() => {
				const dom = this.$refs[`media_${this.currIdx}_${this.currDetailClickIdx}`]
				if (dom && dom[0]) {
					dom[0].play()
				}
			})
		}
	},
};
</script>

<style scoped lang="less">
.enterprise_re {
	width: 100%;
	height: 722px;
	padding-top: 81px;
	box-sizing: border-box;
	background: #FFFFFF;
	position: relative;
	touch-action: pan-y;
	.title {
		color: #000;
		text-align: center;
		font-family: PingFang SC;
		font-size: 26px;
		font-weight: 500;
		line-height: normal;
	}
	.tabs_box {
    width: 296px;
    height: 32px;
		background-color: rgba(97, 99, 105, 0.15);
    user-select: none;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-radius: 20px;
    margin: 20px auto 0;
    &_1 {
      width: 102px;
    }
    &_2 {
      width: 104px;
    }
		&_3 {
      width: 90px;
    }
    &_1,
    &_2,
		&_3 {
      color: #616369;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: normal; 
      text-align: center;
      z-index: 1;
      transition: color .3s;
      &.active {
        color: #ffffff;
      }
    }
    &_bg {
      position: absolute;
      left: 0;
      width: 102px;
      height: 100%;
      background: #000000;
      border-radius: 20px;
      transition: left 0.3s, width 0.3s;
      z-index: 0;
    }
  }
	.content-wrap {
		width: 100%;
		height: 458px;
		margin-top: 28px;
		position: relative;
		.item_box {
			width: 100%;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			opacity: 0;
			z-index: 0;
			&.active {
				opacity: 1;
				z-index: 1;
			}
			.dt-title {
				margin: 0 auto;
				width: 335px;
				font-family: PingFang SC;
				font-size: 20px;
				font-weight: 400;
				line-height: 29px;
				letter-spacing: 1px;
				color: rgba(68, 69, 70, 1);
				text-align: center;
			}
			.video_box {
				margin: 20px auto 0;
				width: 280px;
				height: 190px;
				box-sizing: border-box;
				border: 6px solid #444546;
				border-radius: 12px;
				overflow: hidden;
				.media_item {
					width: 100%;
					height: 100%;
					overflow: hidden;
					background: #444546;
					display: flex;
					align-items: center;
					justify-content: center;
					video {
						width: 280px;
						height: auto;
						border-radius: 12px;
						object-fit: fill;
					}
					img {
						width: 280px;
						height: auto;
						border-radius: 12px;
						object-fit: fill;
					}
				}
			}
			.text_box {
				position: relative;
				margin-top: 25px;
				.detail_box {
					position: relative;
					width: 100%;
					height: 122px;
					.detail_item {
						width: 100%;
						position: absolute;
						top: 0;
						opacity: 0;
						z-index: 0;
						&.active {
							opacity: 1;
							z-index: 1;
						}
						.dt-text {
							width: 335px;
							margin: 10px auto 0;
							font-family: PingFang SC;
							font-size: 14px;
							font-weight: 400;
							line-height: 20px;
							letter-spacing: 0px;
							text-align: center;
							color: rgba(68, 69, 70, 1);
							&:first-of-type {
								margin-top: 0;
							}
						}
					}
				}
			}
		}
		.indicator_wrap {
			position: absolute;
      width: 100%;
      bottom: 7px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .indicator_item {
        display: block;
        width: 8px;
        height: 8px;
        background-color: rgba(217, 217, 217, 1);
        border-radius: 50%;
        margin-right: 12px;
        &:last-of-type {
          margin-right: 0;
        }
        &.active {
          background-color: rgba(0, 112, 249, 1);
        }
      }
		}
	}
	.dl_btn {
		position: absolute;
		bottom: 40px;
		left: 50%;
		transform: translateX(-50%);
		user-select: none;
		width: 180px;
		height: 40px;
		background-color: #0070f9;
		border-radius: 6px;
		font-family: 'PingFang SC';
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.3s;
		margin: 0 auto;
		&:active {
			background-color: rgba(0, 112, 255, 0.8);
		}
	}
}
</style>